import React from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'

const ADDON_TYPE_DATA = 'data'
const ADDON_TYPE_MINUTES = 'minutes'
const ADDON_TYPE_PAYG = 'payg'

const BuyMobileAddOns = (props) => {
    const handleToggle = (event, item) => {
        event.preventDefault()
        if (item.isAllowed) {
            props.handleToggle(`${item.id}-${item.charge}`)
        }
    }

    const addOnSelected = addOn => {
        if (props.selectedAddOns.includes(`${addOn.id}-${addOn.charge}`)) {
            return 'active'
        }

        return ''
    }

    return (
        <div className='row buy-mobile-add-ons'>
            <div className='col-12 d-none d-lg-block'>
                <table cellPadding='0' cellSpacing='0'>
                    <thead>
                        <tr>
                            {props.addOns.map((item, key) => {
                                return <td key={key} className={addOnSelected(item)}>{item.title}</td>
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {props.addOns.map((item, key) => {
                                return (
                                    <td key={key} className={addOnSelected(item)}>
                                        <span className='bold font-medium'>{item.price}</span>
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            {props.addOns.map((item, key) => {
                                return (
                                    <td key={key} className={addOnSelected(item)}>
                                        <Product addOn={item} />
                                    </td>
                                )
                            })}
                        </tr>
                        <tr className='font-small'>
                            {props.addOns.map((item, key) => {
                                return (
                                    <td key={key} className={addOnSelected(item)}>
                                        <Features type={item.addonType} expiry={item.expiry} />
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            {props.addOns.map((item, key) => {
                                return (
                                    <td key={key} className={addOnSelected(item)}>
                                        <Button
                                            title={!item.isAllowed ? 'Purchased' : addOnSelected(item) ? 'Selected' : 'Select'}
                                            action={event => handleToggle(event, item)}
                                            className={!item.isAllowed ? 'disabled' : ''}
                                        />
                                    </td>
                                )
                            })}
                        </tr>
                        <tr>
                            {props.addOns.map((item, key) => {
                                return <td key={key}><small>Total min {item.totalMinCost}</small></td>
                            })}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className='col-12 d-lg-none'>
                {props.addOns.map((item, key) => {
                    return (
                        <div
                            key={key}
                            className={`buy-mobile-add-ons-mobile mb-3 ${addOnSelected(item)} ${!item.isAllowed ? 'disabled' : ''}`}
                            onClick={event => handleToggle(event, item)}
                        >
                            <div className='header d-flex align-items-center'>
                                <div className='d-inline-block w-50'>
                                    {item.title} {!item.isAllowed ? <span style={{ fontStyle: 'italic' }}>(purchased)</span> : ''}
                                </div>
                                <div className='d-inline-flex w-50 justify-content-end align-items-center'>
                                    <div>
                                        <span className='bold'>{item.price}</span>
                                    </div>
                                    <div className='tick ml-2' />
                                </div>
                            </div>
                            <div className='body font-small'>
                                <p className='m-0 my-2'><Product addOn={item} /></p>
                                <p className='m-0 my-2'><Features type={item.addonType} /></p>
                                <p className='m-0 mt-3'>Total min {item.totalMinCost}</p>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

BuyMobileAddOns.propTypes = {
    addOns: PropTypes.array.isRequired,
    selectedAddOns: PropTypes.array.isRequired,
    handleToggle: PropTypes.func.isRequired
}

export default BuyMobileAddOns

const Product = (props) => {
    if (props.addOn.addonType === ADDON_TYPE_DATA) {
        return <span className='font-medium'>{props.addOn.product}</span>
    }

    return <span className='font-small'>{props.addOn.product}</span>
}

const Features = (props) => {
    if (props.expiry !== false) {
        return <span>{props.expiry}</span>
    } else if (props.type === ADDON_TYPE_DATA) {
        return <span>Add-on data expires with your underlying cycle expiry date. Unused <span className='bold'>data rollover</span> into Data Bank</span>
    } else if (props.type === ADDON_TYPE_MINUTES) {
        return <span>30 day expiry. To view included countries see 'Things you need to know' below.</span>
    } else if (props.type === ADDON_TYPE_PAYG) {
        return <span>Your PAYG balance expires when used up. Any unused balance will transfer if you change recharge plan. To view international call rates see link below.</span>
    }

    return ''
}



// WEBPACK FOOTER //
// ./resources/js/components/BuyMobileAddOns.js